import { LoadingStatus, needsLoading, GoAction } from '@app/core';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { selectRoles, LoadingRolesAction, SelectRoleAction, RemoveRoleByIdAction, LoadingRoleDetailsAction, LoadingOrgRolesAction } from '@app/access-management/state';
import { take, filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var shouldLoadRoles = function (roles) { return needsLoading(roles); };
var ɵ0 = shouldLoadRoles;
var hasRoleState = function (roles) { return !needsLoading(roles); };
var ɵ1 = hasRoleState;
var RolesFacadeService = /** @class */ (function () {
    function RolesFacadeService(store) {
        this.store = store;
        this.roles$ = of();
        this.LOAD_COMPLETE = LoadingStatus.LOAD_COMPLETE;
        this.loading$ = of();
        this.loaded$ = of();
        this.loadFailed$ = of();
    }
    RolesFacadeService.prototype.initialize = function () {
        var _this = this;
        var maybeRoles$ = this.store.pipe(select(selectRoles));
        maybeRoles$
            .pipe(take(1), filter(shouldLoadRoles))
            .subscribe(function () { return _this.store.dispatch(new LoadingRolesAction()); });
        this.roles$ = maybeRoles$.pipe(filter(hasRoleState));
        this.loading$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOADING; }));
        this.loaded$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOAD_COMPLETE; }));
        this.loadFailed$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOAD_FAILED; }));
    };
    RolesFacadeService.prototype.loadOrganizationRoles = function (orgId) {
        var _this = this;
        var maybeRoles$ = this.store.pipe(select(selectRoles));
        maybeRoles$
            .pipe(take(1), filter(shouldLoadRoles))
            .subscribe(function () { return _this.store.dispatch(new LoadingOrgRolesAction(orgId)); });
        this.roles$ = maybeRoles$.pipe(filter(hasRoleState));
        this.loading$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOADING; }));
        this.loaded$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOAD_COMPLETE; }));
        this.loadFailed$ = this.roles$.pipe(map(function (roles) { return roles.status === LoadingStatus.LOAD_FAILED; }));
    };
    RolesFacadeService.prototype.selectRole = function (role) {
        this.store.dispatch(new SelectRoleAction(role));
    };
    RolesFacadeService.prototype.removeRoleById = function (roleId) {
        this.store.dispatch(new RemoveRoleByIdAction(roleId));
    };
    RolesFacadeService.prototype.goToEditRole = function (row) {
        this.store.dispatch(new LoadingRoleDetailsAction(row.id));
        this.store.dispatch(new GoAction(['/iam/roles', row.id, 'edit']));
    };
    RolesFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function RolesFacadeService_Factory() { return new RolesFacadeService(i0.inject(i1.Store)); }, token: RolesFacadeService, providedIn: "root" });
    return RolesFacadeService;
}());
export { RolesFacadeService };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/state/roles.facade.ts.pre-build-optimizer.js